<!-- <div class="container-fluid p-0 backgroudtheme">
  <div class="row">
    <div class="col-1">
      <app-nav [admin]="false"></app-nav>
    </div>
    <div class="col-11">
      <router-outlet></router-outlet>
    </div>
  </div>
</div> -->

<app-nav [admin]="false"></app-nav>
<router-outlet></router-outlet>
